import { useState } from "react";
import { apiUrl } from "../api-url";
export function AppIssueForm() {
	const [text, setText] = useState(""),
		[notice, setNotice] = useState(""),
		[id, setId] = useState(""),
		[busy, setBusy] = useState(false);
	return (
		<details className="workspace-disclosure">
			<summary>이 화면 문제 알리기</summary>
			<p>
				개인정보·숙소 주소·예약번호는 쓰지 마세요. 글·화면 종류·브라우저 종류만
				보내요. 90일 안에 삭제해요.
			</p>
			<form
				noValidate
				onSubmit={async (e) => {
					e.preventDefault();
					if (text.trim().length < 10) {
						setNotice("문제 상황을 10자 이상 적어 주세요.");
						return;
					}
					if (!navigator.onLine) {
						setNotice(
							"연결되면 다시 눌러 주세요. 쓴 글은 이 화면에 남겨 뒀어요.",
						);
						return;
					}
					setBusy(true);
					try {
						const screen = location.pathname.startsWith("/trips")
								? "trip"
								: location.pathname === "/s"
									? "share"
									: "support",
							browser = /iPhone|iPad/.test(navigator.userAgent)
								? "ios"
								: /Android/.test(navigator.userAgent)
									? "android"
									: "desktop";
						const response = await fetch(apiUrl("/api/v1/corrections"), {
							method: "POST",
							headers: {
								"content-type": "application/json",
								"Idempotency-Key": crypto.randomUUID(),
							},
							body: JSON.stringify({
								entityType: "app",
								entityId: `${screen}:${browser}`,
								sourceUrl: "https://japangolmok.com/support",
								message: text.trim().slice(0, 500),
								website: "",
							}),
						});
						if (!response.ok) throw new Error("FAILED");
						const data = (await response.json()) as { id?: unknown };
						if (typeof data.id !== "string") throw new Error("FAILED");
						setId(data.id);
						setNotice("문제를 접수했어요.");
					} catch {
						setNotice(
							"지금은 보내지 못했어요. 작성한 글은 남겨 뒀어요. 연결을 확인하고 다시 눌러 주세요.",
						);
					} finally {
						setBusy(false);
					}
				}}
			>
				<label>
					어떤 문제가 있었나요?
					<textarea
						maxLength={500}
						rows={5}
						value={text}
						onChange={(e) => setText(e.target.value)}
					/>
				</label>
				<button type="submit" className="button secondary" disabled={busy}>
					{busy ? "보내는 중…" : "문제 보내기"}
				</button>
			</form>
			<p role="status">
				{notice}
				{id && ` · 접수 번호 ${id}`}
			</p>
		</details>
	);
}
